import React, { useState } from 'react';
import './ConnectionForm.css';

export default function ConnectionForm({ onConnect, isConnecting }) {
  const [url, setUrl] = useState(process.env.REACT_APP_LIVEKIT_URL || '');
  const [token, setToken] = useState(process.env.REACT_APP_LIVEKIT_TOKEN || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (url && token) {
      onConnect(url, token);
    }
  };

  return (
    <div className="connection-screen">
      <div className="connection-card">
        <div className="connection-logo">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="12" fill="#7c5cfc" fillOpacity="0.15" />
            <path
              d="M24 14L14 20v8l10 6 10-6v-8l-10-6z"
              stroke="#7c5cfc"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path d="M24 28v6" stroke="#7c5cfc" strokeWidth="2" />
            <path d="M14 20l10 8 10-8" stroke="#7c5cfc" strokeWidth="2" strokeLinejoin="round" />
          </svg>
        </div>
        <h1>Cultivate</h1>
        <p className="connection-subtitle">AI Interview Demo Assistant</p>

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="lk-url">LiveKit Server URL</label>
            <input
              id="lk-url"
              type="text"
              placeholder="wss://your-server.livekit.cloud"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              required
            />
          </div>
          <div className="form-field">
            <label htmlFor="lk-token">Access Token</label>
            <input
              id="lk-token"
              type="password"
              placeholder="Participant token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="connect-btn" disabled={isConnecting}>
            {isConnecting ? 'Connecting...' : 'Join Session'}
          </button>
        </form>
      </div>
    </div>
  );
}
